import Tabs from './Tabs';

export default Tabs;

export {
	Tabs
};
